import React, { FC, useState } from 'react';
import { ReactComponent as SwitchToPickupIcon } from 'assets/icons/update-surge-modal-icon.svg';
import { toast } from 'react-toastify';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { OrderType } from 'models/order.model';
import { apiService } from 'utils/api';

enum DeliveryTypes {
  PICKUP = 'pickup',
  DELIVERY = 'delivery'
}

interface SwitchToPickupModalProps {
  show: boolean;
  onClose: () => void;
  onComplete?: () => void;
  order: OrderType;
}

interface SwitchToPickupFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const SwitchToPickupFooter: FC<SwitchToPickupFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const SwitchToPickupModal: FC<SwitchToPickupModalProps> = ({ show, onClose, order }) => {
  const [loading, setLoading] = useState(false);
  const isDelivery = !order.calculated_order.pickup;
  const newDeliveryTypeText = isDelivery ? 'Pick-up' : 'Delivery';
  const sendValues = async () => {
    setLoading(true);
    try {
      await apiService.post('logistics/order/delivery-type/switch', {
        data: {
          order_id: order.id,
          cokitchen_polygon_id: order.calculated_order.cokitchen_polygon_id,
          delivery_type: isDelivery ? DeliveryTypes.PICKUP : DeliveryTypes.DELIVERY
        },
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(<ToastMessage type='success' message='Order switched successfully' />);
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      isOpen={show}
      title={'Switch to ' + newDeliveryTypeText}
      description={
        `Are you sure you want to switch order #${order?.order_code?.toUpperCase() ?? ''} to ` +
        newDeliveryTypeText.toLowerCase()
      }
      titleIcon={<SwitchToPickupIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      footer={<SwitchToPickupFooter loading={loading} onCancel={onClose} onConfirm={sendValues} />}
    />
  );
};

export default SwitchToPickupModal;
